import Injectable from '../../../domain/di/injectable';
import HttpConnector from '../../../domain/connectors/http';

@Injectable()
export default class FetchHttpConnector implements HttpConnector {
  async execute(
    path: string,
    method = 'GET',
    body = undefined,
    retries = 0,
    keepalive = false,
    headers: Record<string, string> = {
      Authorization: `Bearer ${sessionStorage.getItem('authorization')}` || '',
      'Content-Type': 'application/json',
    },
  ): Promise<Response> {
    try {
      const response = await fetch(path, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
        keepalive,
      });

      if (!response.ok && retries > 0) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(this.execute(path, method, body, retries - 1, keepalive, headers));
          }, 1000);
        });
      }

      return response;
    } catch {
      if (retries > 0) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(this.execute(path, method, body, retries - 1, keepalive, headers));
          }, 1000);
        });
      }

      return Promise.reject(new Error('Fetch Error'));
    }
  }
}
